import type { ContractRenewalRequestPayload, ContractRenewalResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import {
  invalidateContractsQueries,
  invalidateCustomersQueries,
  invalidateBillingRevenueQueries,
} from '../../utils/query-invalidation';

export function useRenewContract(
  contractId: string,
  options?: UseMutationOptions<ContractRenewalResponse, unknown, ContractRenewalRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['renew-contract'],
    ({ startDate }) => {
      const api = getPrivateApi();

      return api.renewContract({
        contractId,
        renewContractRequest: { startDate },
      });
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey.includes(contractId),
          }),
          invalidateContractsQueries(queryClient),
          invalidateCustomersQueries(queryClient),
          invalidateBillingRevenueQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}
